import Booking from '../screens/Booking'
import BookingCitySearchResult from '../screens/BookingCitySearchResult'
import BookingDetailsModify from '../screens/BookingDetailsModify'
import BookingDetailsResults from '../screens/BookingDetailsResults'
import BookingHotelSearchResult from '../screens/BookingHotelSearchResult'
import BookingList from '../screens/BookingList'
import BookingStepper from '../screens/BookingStepper'
import ChangeReservationConfirm from '../screens/ChangeReservationConfirm'
import SelectChannel from '../screens/SelectChannel'
import Voucher from '../screens/voucher'
import { ROLE, RouteWithAccessType } from './types'

const bookRoleManagement: RouteWithAccessType[] = [
  {
    route: '/book/select-channel',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.CHANNEL,
      ROLE.ACCOMMODATION,
      ROLE.ACCOMMODATION_OPERATOR,
      ROLE.PROVIDER
    ],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['booking.create'],
    component: <SelectChannel />
  },
  {
    route: '/book/:channelId/:code/:name',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.CHANNEL,
      ROLE.ACCOMMODATION,
      ROLE.ACCOMMODATION_OPERATOR,
      ROLE.PROVIDER
    ],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['booking.create'],
    component: <Booking />
  },
  {
    route: '/book/:channelId/:code/:name/city',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.CHANNEL,
      ROLE.ACCOMMODATION,
      ROLE.ACCOMMODATION_OPERATOR,
      ROLE.PROVIDER
    ],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['booking.create'],
    component: <BookingCitySearchResult />
  },
  {
    route: '/book/:channelId/:code/:name/hotel',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.CHANNEL,
      ROLE.ACCOMMODATION,
      ROLE.ACCOMMODATION_OPERATOR,
      ROLE.PROVIDER
    ],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['booking.create'],
    component: <BookingHotelSearchResult />
  },
  {
    route: '/book/:channelId/:code/:name/bookstepper/:page/:reservationNumber?',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.CHANNEL,
      ROLE.ACCOMMODATION,
      ROLE.ACCOMMODATION_OPERATOR,
      ROLE.PROVIDER
    ],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['booking.create'],
    component: <BookingStepper />
  },
  {
    route: '/booking/list/:reserveNumber/view',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.PROVIDER_MARKETING,
      ROLE.PROVIDER_IT,
      ROLE.PROVIDER_FINANCE,
      ROLE.PROVIDER_MANAGEMENT,
      ROLE.ACCOMMODATION,
      ROLE.ACCOMMODATION_OPERATOR,
      ROLE.CHANNEL,
      ROLE.CHANNEL_ADMIN
    ],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['booking.details.view'],
    sections: {
      GET_PMS_EVENT: {
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_FINANCE,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.ACCOMMODATION,
          ROLE.CHANNEL,
          ROLE.CHANNEL_ADMIN
        ],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['booking.pms.event.view']
      },
      CHANGE_RESERVE_DETAILS: {
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['booking.admin.edit']
      },
      CHECK_STATUS: {
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['booking.status.check']
      }
    },
    component: <BookingDetailsResults />
  },
  {
    route: '/booking/list/:reserveNumber/edit',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.CHANNEL,
      ROLE.ACCOMMODATION,
      ROLE.ACCOMMODATION_OPERATOR,
      ROLE.PROVIDER
    ],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['booking.details.modify'],
    component: <BookingDetailsModify />
  },
  {
    route: '/booking/list/:reserveNumber/edit/:page/:roomReservationNumber?',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.CHANNEL,
      ROLE.ACCOMMODATION,
      ROLE.ACCOMMODATION_OPERATOR,
      ROLE.PROVIDER
    ],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['booking.details.view'],
    component: <ChangeReservationConfirm />
  },
  {
    route: '/booking/list/:reserveNumber/vouherPdf',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.TENANT,
      ROLE.ACCOMMODATION,
      ROLE.ACCOMMODATION_OPERATOR,
      ROLE.TENANT_MARKETING,
      ROLE.PROVIDER_MARKETING,
      ROLE.TENANT_IT,
      ROLE.PROVIDER_IT,
      ROLE.TENANT_FINANCE,
      ROLE.PROVIDER_FINANCE,
      ROLE.CHANNEL,
      ROLE.CHANNEL_ADMIN
    ],
    rolesListWithWriteAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.TENANT,
      ROLE.ACCOMMODATION,
      ROLE.TENANT_MARKETING,
      ROLE.PROVIDER_MARKETING,
      ROLE.CHANNEL,
      ROLE.CHANNEL_ADMIN
    ],
    requiredFeatures: ['booking.voucher.view'],
    component: <Voucher />
  },
  {
    route: '/booking/list',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.PROVIDER_MARKETING,
      ROLE.PROVIDER_IT,
      ROLE.PROVIDER_FINANCE,
      ROLE.PROVIDER_MANAGEMENT,
      ROLE.ACCOMMODATION,
      ROLE.ACCOMMODATION_OPERATOR,
      ROLE.CHANNEL,
      ROLE.CHANNEL_ADMIN,
      ROLE.TENANT,
      ROLE.TENANT_MARKETING
    ],
    rolesListWithWriteAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.PROVIDER_MARKETING,
      ROLE.PROVIDER_IT,
      ROLE.PROVIDER_FINANCE,
      ROLE.PROVIDER_MANAGEMENT,
      ROLE.ACCOMMODATION,
      ROLE.CHANNEL,
      ROLE.CHANNEL_ADMIN,
      ROLE.TENANT,
      ROLE.TENANT_MARKETING
    ],
    requiredFeatures: ['booking.list.view'],
    component: <BookingList />,
    sections: {
      VIEW_BOOKING_DETAILS_BUTTON: {
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.TENANT,
          ROLE.ACCOMMODATION,
          ROLE.ACCOMMODATION_OPERATOR,
          ROLE.TENANT_MARKETING,
          ROLE.PROVIDER_MARKETING,
          ROLE.TENANT_IT,
          ROLE.PROVIDER_IT,
          ROLE.TENANT_FINANCE
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.TENANT,
          ROLE.ACCOMMODATION,
          ROLE.TENANT_MARKETING
        ],
        requiredFeatures: ['booking.details.view']
      },
      VIEW_BOOKING_LIST_EXCEL: {
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.PROVIDER_IT,
          ROLE.PROVIDER_FINANCE,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.ACCOMMODATION,
          ROLE.CHANNEL,
          ROLE.CHANNEL_ADMIN,
          ROLE.TENANT,
          ROLE.TENANT_FINANCE,
          ROLE.TENANT_IT,
          ROLE.TENANT_MANAGEMENT,
          ROLE.TENANT_MARKETING,
          ROLE.TENANT_PR
        ],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['booking.details.view']
      },
      TENANT_SELECTOR: {
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['booking.details.view']
      },
      ACCOMMODATION_SELECTOR: {
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING,
          ROLE.PROVIDER_MARKETING,
          ROLE.TENANT_IT,
          ROLE.PROVIDER_IT,
          ROLE.TENANT_FINANCE,
          ROLE.PROVIDER_FINANCE,
          ROLE.TENANT_MANAGEMENT,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.TENANT_PR,
          ROLE.PROVIDER_PR,
          ROLE.CHANNEL,
          ROLE.CHANNEL_ADMIN
        ],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['booking.details.view']
      },
      CHANNEL_SELECTOR: {
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING,
          ROLE.PROVIDER_MARKETING,
          ROLE.TENANT_IT,
          ROLE.PROVIDER_IT,
          ROLE.TENANT_FINANCE,
          ROLE.PROVIDER_FINANCE,
          ROLE.TENANT_MANAGEMENT,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.TENANT_PR,
          ROLE.PROVIDER_PR,
          ROLE.ACCOMMODATION,
          ROLE.ACCOMMODATION_OPERATOR
        ],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['booking.details.view']
      },
      IS_CHANNEL: {
        rolesListWithReadAccess: [
          ROLE.CHANNEL,
          ROLE.CHANNEL_ADMIN,
          ROLE.CHANNEL_ACTIVATION
        ],
        rolesListWithWriteAccess: [
          ROLE.CHANNEL,
          ROLE.CHANNEL_ADMIN,
          ROLE.CHANNEL_ACTIVATION
        ],
        requiredFeatures: ['booking.details.view']
      }
    }
  },
  {
    route: '/booking/list/?filter=:filters',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.TENANT,
      ROLE.ACCOMMODATION,
      ROLE.ACCOMMODATION_OPERATOR,
      ROLE.TENANT_MARKETING,
      ROLE.PROVIDER_MARKETING,
      ROLE.TENANT_IT,
      ROLE.PROVIDER_IT,
      ROLE.TENANT_FINANCE
    ],
    rolesListWithWriteAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.TENANT,
      ROLE.ACCOMMODATION,
      ROLE.TENANT_MARKETING
    ],
    requiredFeatures: ['booking.list.view'],
    component: <BookingList />
  }
]

export default bookRoleManagement
